export default __webpack_public_path__ + "static/media/dalenhand.2bc42d1f.jpg";